import { client, dataCollector } from 'braintree-web';

export async function getBraintreeDeviceData(BTClientToken: string) {
  const BTClient = await client.create({ authorization: BTClientToken });
  const BTDataCollector = await dataCollector.create({ client: BTClient, paypal: true });
  return BTDataCollector.deviceData;
}
